var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoNetwork(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 113,
    viewBox: "0 0 114 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 113,
    height: 113,
    rx: 19.0986,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3950_129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.262 53.5548C70.1486 54.2832 71.447 54.2198 72.2545 53.4123C73.1886 52.4782 73.1253 50.9265 72.0961 50.0873C66.412 45.4323 59.1128 43.7065 52.2253 44.9257L56.3261 49.0265C60.902 48.979 65.5095 50.4832 69.262 53.5548ZM65.6678 56.4523C64.4328 55.5498 63.087 54.869 61.6778 54.394L66.3486 59.0648C66.7286 58.1465 66.507 57.054 65.6678 56.4523ZM59.5878 63.1973C57.6561 62.1998 55.3445 62.1998 53.397 63.1973C52.4628 63.6882 52.2886 64.9707 53.0328 65.7148L55.3603 68.0423C55.9778 68.6598 56.9753 68.6598 57.5928 68.0423L59.9203 65.7148C60.6961 64.9707 60.5378 63.6882 59.5878 63.1973ZM68.6603 65.8415L44.0236 41.2048C43.4061 40.5873 42.4086 40.5873 41.7911 41.2048C41.1736 41.8223 41.1736 42.8198 41.7911 43.4373L45.4961 47.1582C43.897 47.9498 42.3453 48.9157 40.9203 50.0873C39.8911 50.9265 39.8278 52.4782 40.762 53.4123C41.5695 54.2198 42.852 54.299 43.7228 53.5707C45.3061 52.2723 47.0478 51.259 48.8686 50.5148L52.3995 54.0457C50.6103 54.5207 48.9003 55.3123 47.3486 56.4365C46.2561 57.2282 46.1928 58.8273 47.1428 59.7773L47.1586 59.7932C47.9345 60.569 49.1536 60.6482 50.0561 59.999C51.9403 58.669 54.1411 58.004 56.342 57.9565L66.4278 68.0423C67.0453 68.6598 68.0428 68.6598 68.6603 68.0423C69.2778 67.4565 69.2778 66.459 68.6603 65.8415Z",
    fill: "#A8A8A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3950_129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(37.5 37.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNetwork);
export default __webpack_public_path__ + "static/media/no-network.b95152cef1992ca47a2f68a8fae82683.svg";
export { ForwardRef as ReactComponent };